import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { GetActualRegistrationFormsForAssociationResponseDto } from '@src/api';
import { Language } from '@src/core';

@Component({
  selector: 'new-list-item-moderation-user',
  templateUrl: './list-item-moderation-user.component.html',
  styleUrls: ['./list-item-moderation-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemModerationUserComponent implements OnChanges {
  private readonly translateService = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() user?: GetActualRegistrationFormsForAssociationResponseDto;

  registrationLabel?: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.user) {
      const registrationDate = this.user?.dateRegistered
        ? formatDate(this.user.dateRegistered, 'dd.MM.yyyy', Language.EN)
        : undefined;

      if (registrationDate) {
        this.registrationLabel = this.translateService.instant(
          'components.listItemRegistrationUsers.labels.registrationDate',
          {
            value: registrationDate,
          },
        );
      }
    }

    this.cdr.markForCheck();
  }
}
